import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import TotalApproved from "../../../../images/icons/total-approved.svg";

// Functional component
function TotalApprovedRequestsTimeOff({ timeoffReq }) {
  const [displayedCount, setDisplayedCount] = useState(0);
  const [targetCount, setTargetCount] = useState(0);
  const animationFrameRef = useRef(null);
  const reportingTimeoffRequest = useSelector((state) => state.reportingTimeoffRequest);

  useEffect(() => {
    if (timeoffReq && Array.isArray(timeoffReq)) {
      const filteredTimeoffReqs = timeoffReq.filter(tor => {
        const isUserDetailMatch = !reportingTimeoffRequest.timeoffReqUser || reportingTimeoffRequest.timeoffReqUser.includes(tor.user?._id);
        const isStatusDetailMatch = !reportingTimeoffRequest.timeoffReqReqStatus || reportingTimeoffRequest.timeoffReqReqStatus.includes(tor.status);
        const isNotDeleted = !tor.is_delete;
        const isYearMatch = !reportingTimeoffRequest.timeoffReqYear ||
          new Date(tor?.end_date).getFullYear() === reportingTimeoffRequest.timeoffReqYear;
        const isCategoryMatch = reportingTimeoffRequest.timeoffReqCategory && reportingTimeoffRequest.timeoffReqCategory.includes(tor.type_of_leave._id)
        return isUserDetailMatch && isStatusDetailMatch && isNotDeleted && isYearMatch && isCategoryMatch;
      });

      const approvedRequestCount = filteredTimeoffReqs.filter(tor => tor.status === 'Approved').length;
      setTargetCount(approvedRequestCount || 0);
    } else {
      setTargetCount(0);
    }
  }, [timeoffReq, reportingTimeoffRequest]);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedCount;
    const endValue = targetCount;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedCount(Math.floor(currentValue));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedCount(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetCount]);

  return (
    <div>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">Total Approved</div>
          <div className="overview-icon">
            <img src={TotalApproved} alt="cLock" />
          </div>
        </div>

        <div className="overview-rice">
          {displayedCount}
        </div>
      </div>
    </div>
  );
}

export default TotalApprovedRequestsTimeOff;
